import type { SystemStyleObject } from '@companydotcom/potion';

const parts = ['container', 'divider', 'form', 'formButton'];

const baseStyleContainer: SystemStyleObject = {
  paddingTop: 14,
  paddingBottom: '80px',
  maxWidth: 776,
  marginX: 'auto',
  paddingX: 5,
};

const baseStyleDivider: SystemStyleObject = {};

const baseStyleForm: SystemStyleObject = {
  width: 'full',
};

const baseStyleFormButton: SystemStyleObject = {};

const baseStyleFields: SystemStyleObject = {
  paddingY: [10],
};

const baseStyle = () => ({
  container: baseStyleContainer,
  divider: baseStyleDivider,
  form: baseStyleForm,
  formButton: baseStyleFormButton,
  fields: baseStyleFields,
});

export default {
  parts,
  baseStyle,
};
